import React from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { PainSection } from './components/PainSection';
import { PackContent } from './components/PackContent';
import { ProfessionalSystem } from './components/ProfessionalSystem';
import { Bonuses } from './components/Bonuses';
import { ValueStack } from './components/ValueStack';
import { Pricing } from './components/Pricing';
import { ComparisonTable } from './components/ComparisonTable';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <div className="relative min-h-screen bg-black text-white selection:bg-orange-500/30 selection:text-orange-200 overflow-hidden" data-id="element-0">
      {/* Single static purple radial gradient (no blur filter, no fixed positioning) */}
      <div className="pointer-events-none absolute inset-0 z-0" style={{
      background: 'radial-gradient(ellipse 70% 55% at 50% 30%, rgba(168,85,247,0.28) 0%, rgba(168,85,247,0.12) 35%, rgba(168,85,247,0.04) 60%, rgba(0,0,0,0) 80%)'
    }} data-id="element-1" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 py-6" data-id="element-2">
        <Hero data-id="element-3" />
        <SocialProof data-id="element-4" />
        <PainSection data-id="element-5" />
        <PackContent data-id="element-6" />
        <ProfessionalSystem data-id="element-7" />
        <Bonuses data-id="element-8" />
        <ValueStack data-id="element-9" />
        <Pricing data-id="element-10" />
        <ComparisonTable data-id="element-11" />
        <Testimonials data-id="element-12" />
        <Guarantee data-id="element-13" />
        <FAQ data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </div>
    </div>;
}